import type { ApiFetchGameFilterOptionsPort } from '~/handlers/ports/api-fetch-game-filter-options.port';
import { getApostatudoApiUrl } from '~/utils/apostatudo/get-apostatudo-api-url';

export class ApostatudoApiFetchGameFilterOptionsAdapter
  implements ApiFetchGameFilterOptionsPort
{
  async handle(): Promise<GameFilterOptionsResponse> {
    const url = `${getApostatudoApiUrl()}/games/filter-options`;

    const response = await fetch(url, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    });

    if (!response.ok) {
      throw new Error(`API Error: ${response.status} ${response.statusText}`);
    }

    const result: GameFilterOptionsResponse = await response.json();

    return result;
  }
}
